import { CobaltSidePanel } from '@cae/cobalt-react/components/side-panel';
import { MediaQuery } from '@cae/cobalt-react/enums';
import { useMediaQuery } from '@cae/cobalt-react/hooks';
import { useHasPermission } from '@contexts/permissions-provider';
import * as React from 'react';

import type { ApprovalLetterPanelShellProps } from './ApprovalLetterPanelShell.types';

import { ApprovalLetterPanelContent } from '../approval-letter-panel-content/ApprovalLetterPanelContent';

const ApprovalLetterPanelShell = React.memo(
  ({
    onClose,
  }: Readonly<ApprovalLetterPanelShellProps>): React.ReactElement => {
    const isMobileOrTablet = useMediaQuery(MediaQuery.MobileAndTablet);
    const canUploadLetter = useHasPermission('InstructorApproval_Add_Org');

    return (
      <CobaltSidePanel
        isOpen
        onClose={onClose}
        showCloseButton
        size={isMobileOrTablet ? 'large' : 'medium'}
        title="Upload approval letters"
        description="The following check airmen require their approval letter, please upload them below."
      >
        <ApprovalLetterPanelContent canUploadLetter={canUploadLetter} />
      </CobaltSidePanel>
    );
  }
);

ApprovalLetterPanelShell.displayName = 'ApprovalLetterPanelShell';
export { ApprovalLetterPanelShell };
